import React from 'react';

const LessIsMore = () => {
  return (
    <main className="container flow" style={{ minHeight: '100vh', paddingTop: '48px' }}>
      <h1>The Best Products Feel Invisible</h1>

      <p>
        The best software doesn’t feel like software. It doesn’t demand attention or try to show how clever it is. It just works—so well that people often don’t realise they’re using it.
      </p>
      <p>
        This is what "less is more" really means in product design. Not fewer features, but less friction. Fewer moments where the user has to stop and think, “What now?”
      </p>
      <p>
        If you have to explain how your product works, something’s already off. Ideally, users should flow through it with the same ease they unlock their phone or open a door. Intent and interaction should feel like one continuous motion—intuitive, unspoken.
      </p>
      <p>
        The paradox is that building this kind of simplicity is hard. It takes more thought to make something feel effortless. But once you’ve felt that kind of product, everything else seems clunky.
      </p>
      <p>
        Users shouldn’t feel like they’re using a tool. They should feel like they’re just doing what they wanted to do in the first place.
      </p>
      <p>
        The best products tend to get out of the way.
      </p>
    </main>
  );
};

export default LessIsMore;
